import React from 'react';
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Phone } from "lucide-react";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";

function DriesFaseAansluiting() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="3-fase aansluiting voor meer vermogen - elektricieninarnhem026.nl"
        description="Upgrade naar een 3-fase aansluiting voor uw zware apparatuur, laadpaal of warmtepomp. Onze experts zorgen voor een professionele installatie."
        image="/images/banner.png"
      />
      <Header />
      <HeroSection
        title="3-fase aansluiting voor meer vermogen"
        description="Upgrade naar een 3-fase aansluiting voor uw zware apparatuur, laadpaal of warmtepomp. Onze experts zorgen voor een professionele installatie."
        imageSrc="/images/mt2.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              3-fase meterkast uitbreiden voor nieuwe of bestaande installaties
            </h2>
            <p>
              Heb je een extra groep nodig voor een laadpaal, warmtepomp of
              andere zware apparatuur? Wij breiden je 3-fase meterkast vakkundig
              uit, of het nu gaat om een bestaande installatie of een compleet
              nieuwe aansluiting. Onze experts zorgen voor een veilige en
              efficiënte installatie, volledig afgestemd op jouw
              energiebehoefte.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/uitbereiden.jpg"
              />
            </div>
          </div>
        </div>
        <ActivationSteps />

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              3-fase meterkast uitbreiden voor zwaardere apparatuur
            </h2>
            <p>
              Heb je een laadpaal, warmtepomp of andere zware apparatuur? Wij
              breiden je 3-fase meterkast snel en vakkundig uit, zodat je
              installatie veilig en efficiënt werkt, helemaal afgestemd op je
              energiebehoefte.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>

              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/3fase.png"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Wanneer moet je van 1-fase naar 3-fase overstappen?
            </h2>
            <p>
              Heb je steeds meer apparatuur die veel stroom verbruikt, zoals een
              warmtepomp of laadpaal? Dan is het tijd om je aansluiting van
              1-fase naar 3-fase uit te breiden. Wij helpen je met een veilige
              en efficiënte overstap, zodat je installatie optimaal presteert.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#E6B800] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektricieninarnhem026.nl
              </span>
              <img
                alt="perilex aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/perilex.png"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <FAQ />

      <ServiceHighlights />

      <Reviews />
      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#FFD100] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Offerte aanvragen
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default DriesFaseAansluiting;
